import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class MailService {

    constructor(private http: HttpClient) {

    }

    public sendMail(webEmailSendRequestView: any): Observable<any> {
        return this.http.post("https://www.vocbot.ai/voc-api/web/emailSend", webEmailSendRequestView, {});
    }

}